import 'bootstrap/js/tooltip';
import jQuery from 'jquery';
import { settings } from '../../areas/main/config';
import '../../plugins/jquery.loadmask';
import { error as showError } from '../notify';
import { bindForm, findForm, unbindForm } from './bind';
import { Form } from './model';

const eventId = "konfigure:load";

export function loadForm(container: JQuery, url: string) {
	let form = tryFindForm(container);
	if (!form) {
		return;
	}

	container.mask(settings.strings.loadingMessage);

	unbindForm(container);

	const hash = url && url.split('#')[1];
	window.location.hash = hash || '';

	const error = `Unable to load {url}`;

	try {
		container.load(url, (_, __, jqXhr) => {
			if (jqXhr.status === 200) {
				bindAndRaise(container);
				return;
			}

			if (jqXhr.status !== 401) {
				//401 will cause a location.reload so we don't show an error in that case
				showError(jqXhr.statusText, error);
			}
		});

		return;
	}
	catch (e) {
		console.log(error, e);
		showError((<Error>e).message, error);

		bindAndRaise(container);
		container.unmask();
	}
}

export function loadFormContent(container: JQuery, content: string) {
	let form = tryFindForm(container);
	if (!form) {
		return;
	}

	unbindForm(container);
	container.html(content);
	bindAndRaise(container);
}

export function onLoad(handler: (container: JQuery) => void) {
	jQuery(document).on(eventId, (e: JQuery.TriggeredEvent) => {
		handler(jQuery(e.target));
	});
}

function bindAndRaise(container: JQuery) {
	bindForm(container);
	jQuery(container).trigger(eventId);
}

function tryFindForm(container: JQuery): Form {
	var form = findForm(container);
	if (form && !form.tryConfirmHasChanges()) {
		return null;
	}

	return form;
}
